import { frontendURL } from '../../../../helper/URLHelper';
import SettingsContent from '../Wrapper.vue';
import Usage from './Usage.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/usage'),
      component: SettingsContent,
      meta: {
        permissions: ['administrator'],
      },
      props: {
        headerTitle: 'USAGE_SETTINGS.TITLE',
        icon: 'activity',
        showNewButton: false,
      },
      children: [
        {
          path: '',
          name: 'settings_usage_index',
          component: Usage,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
